import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useParams, Outlet } from 'react-router';
import { Loader } from '@link/share/components';
import { SidebarMenu } from '@link/share/layouts';
import { useStore } from '@link/supplier/stores';
import Header from '../Header';
import styles from './backend.module.css';

const BackendLayout = () => {
  const { t } = useTranslation();
  const { inventory } = useStore();
  const { poolId } = useParams();
  const menuItems = [
    { label: t('layouts.sidebar.backendSettings'), to: 'inventory' },
    { label: t('layouts.sidebar.backendCalendar'), to: 'calendar' }
  ];

  useEffect(() => {
    if (poolId) {
      inventory.getInventory(poolId);
    }
    return () => {
      inventory.clearInventory();
    };
  }, [inventory, poolId]);

  return (
    <div className={styles.backend}>
      <Header />
      <div className={styles.container}>
        <SidebarMenu menuItems={menuItems} />
        <main className={styles.main}>
          <div className={styles.inner}>
            {inventory.loaded ? <Outlet /> : <Loader />}
          </div>
        </main>
      </div>
    </div>
  );
};
const BackendLayoutView = observer(BackendLayout);
export default BackendLayoutView;
